import { render, staticRenderFns } from "./studyRegistrationInformation.vue?vue&type=template&id=ea72abb2&scoped=true"
import script from "./studyRegistrationInformation.vue?vue&type=script&lang=js"
export * from "./studyRegistrationInformation.vue?vue&type=script&lang=js"
import style0 from "./studyRegistrationInformation.vue?vue&type=style&index=0&id=ea72abb2&prod&lang=stylus&scoped=true"
import style1 from "./studyRegistrationInformation.vue?vue&type=style&index=1&id=ea72abb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea72abb2",
  null
  
)

export default component.exports